import { observer } from 'mobx-react-lite'
import { CollapseWithIcon } from 'shared/ui'
import { type Integration } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { IntegrationKeapSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationKeapSettings/store/IntegrationKeapSettingsStore'
import { IntegrationKeapSettingsSync } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationKeapSettings/ui/IntegrationKeapSettingsSync/IntegrationKeapSettingsSync'
import { CollapseIntegrationSettingsProperty } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsProperty/CollapseIntegrationSettingsProperty'
import { CollapseIntegrationSettingsTimeline } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsTimeline/CollapseIntegrationSettingsTimeline'
import { CollapseIntegrationSettingsWebhook } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsWebhook/CollapseIntegrationSettingsWebhook'
import { CollapseIntegrationSettingsUsers } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsUsers/CollapseIntegrationSettingsUsers'
import sharedStyles from 'pages/settings/pages/integrations/pages/integrationSettings/ui/styles.module.scss'

type IIntegrationKeapProps = {
  integration: Integration
}

export const IntegrationKeapSettings = observer(({ integration }: IIntegrationKeapProps) => {
  const entities = useEntitiesContext()
  const { collapseStore, userStore, syncStore, webhookStore, timelineStore, propertyStore } =
    useIntegrationStoreMemo(IntegrationKeapSettingsStore, integration, entities)

  return (
    <div>
      <CollapseIntegrationSettingsUsers collapseStore={collapseStore} userStore={userStore} />
      <CollapseWithIcon
        opened={collapseStore.opened('sync')}
        onClick={collapseStore.onToggle('sync')}
        icon={'arrowHorizontalOutline'}
        title={'Contact syncing'}
        label={syncStore.getLabel}
        headerClassName={sharedStyles.collapseWithIcon}
      >
        <IntegrationKeapSettingsSync store={syncStore} />
      </CollapseWithIcon>
      <CollapseIntegrationSettingsProperty
        collapseStore={collapseStore}
        propertyStore={propertyStore}
        is_1_0_request
      />
      <CollapseIntegrationSettingsTimeline
        collapseStore={collapseStore}
        name={integration.name}
        dailyBundles={timelineStore.dailyBundles}
        onDailyBundlesToggle={timelineStore.onDailyBundlesToggle}
      />
      <CollapseIntegrationSettingsWebhook
        collapseStore={collapseStore}
        webhookStore={webhookStore}
        withLeadOwner
      />
    </div>
  )
})
